import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCallOutgoing: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="call-outgoing, phone"><path d="M15.75 3.75H20.25V8.25M14.75 9.25L19.7532 4.2468M9 3.75L10.25 8L8.36647 9.80819C9.62505 12.3242 11.6758 14.3749 14.1918 15.6335L16 13.75L20.25 15V20.25H20C17.0327 20.25 14.2512 19.4547 11.857 18.0656C9.40402 16.6424 7.35756 14.596 5.93438 12.143C4.54531 9.74877 3.75 6.96726 3.75 4C3.75 3.91652 3.75063 3.83318 3.75188 3.75H9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCallOutgoing;
